import {
  SnackbarVariant,
  SnackbarAction,
} from '@elementary/common-ui/components';
import { atom } from 'recoil';

export const snackbar = atom<{
  open: boolean;
  variant?: SnackbarVariant;
  message?: string;
  actions?: SnackbarAction[];
}>({
  key: 'frontendSnackbar',
  default: { open: false },
});

export const latestPullRequestTimestamp = atom<string>({
  key: 'latestPullRequestTimestamp',
  default: undefined,
});

export const pollingTests = atom<Set<string>>({
  key: 'pollingTests',
  default: new Set(),
});
